import { Container } from '@sbs/bitmovin-player-ui';
import { ContainerConfig } from '@sbs/bitmovin-player-ui/dist/js/framework/components/container';

export default class SbsErrorContainer extends Container<ContainerConfig> {
  constructor(config: ContainerConfig = {}) {
    super(config);
  }
}
